import { useEffect, useReducer } from "react";
import { ReactFlowProvider } from "reactflow";
import { RouterProvider } from "react-router-dom";

import "./App.css";
import appReducer from "./Reducer/app-reducer";
import { USER_DETAILS_KEY, USER_REDUCER_ACTIONS } from "./utils/constant";
import ThemeProviderWrapper from "./theme/ThemeProvider";
import { router } from "./Routes";
import Footer from "./Component/common/Footer";
import MetadataProvider from "./Context/metadataProvider";
import BetaBanner from "./Component/BetaBanner/BetaBanner";
import UserDataProvider from "./Context/user/userDataProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";
import CustomToast from "./Component/Toast/Toast";

function App() {
  const [userData, dispatch] = useReducer(appReducer, { user: {} });

  const clientId = "750109917874-6slr3gtravsqtogqvc450119i6rj8b43.apps.googleusercontent.com";

  useEffect(() => {
    const storedUser = localStorage.getItem(USER_DETAILS_KEY);
    if (storedUser) {
      dispatch({
        type: USER_REDUCER_ACTIONS.INTIALIZE_USER,
        payload: JSON.parse(storedUser),
      });
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <ReactFlowProvider>
        <UserDataProvider>
          <MetadataProvider>
            <ThemeProviderWrapper>
              <CustomToast />
              {/* <BetaBanner /> */}
              <RouterProvider router={router} />
              <Footer />
            </ThemeProviderWrapper>
          </MetadataProvider>
        </UserDataProvider>
      </ReactFlowProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
